import React from 'react';
import { func } from 'prop-types';

import { Container, Tab } from '@ajaibid/components';

import { FormLimitOrder, FormAutoOrder, SwitchOrderPeriod } from '../StockBuySell/components/Forms';
import { useGetOrderTypeOptions, useStockBuySellContext } from '../StockBuySell/hooks';
import { styFormContainer } from '../StockBuySell/style';

const StockAmendForm = (props) => {
  const { code, formState, formKey, formAction, dispatch, isLimitOrder, isAutoOrder } =
    useStockBuySellContext();
  const { orderTypeOptions } = useGetOrderTypeOptions();

  const onChangeOrderType = (v) => {
    dispatch({ type: formAction.CHANGE_ORDER_TYPE, code, payload: v });
  };

  return (
    <Container padding="12px 16px 8px">
      <div className={styFormContainer}>
        <Tab
          tabOptions={orderTypeOptions}
          activeTab={formState[formKey.TAB_ORDER_TYPE]}
          setActiveTab={onChangeOrderType}
        />
        {isLimitOrder && <FormLimitOrder {...props} />}
        {isAutoOrder && <FormAutoOrder {...props} />}
      </div>
      {isLimitOrder && <SwitchOrderPeriod />}
    </Container>
  );
};

StockAmendForm.propTypes = {
  onClickAutoOrderInfo: func,
  onClickAvailableLotInfo: func,
  onSubmit: func,
};

StockAmendForm.defaultProps = {
  onClickAutoOrderInfo: () => {},
  onClickAvailableLotInfo: () => {},
  onSubmit: () => {},
};

export default StockAmendForm;
